export default {
  SET_VISIBLE (state, visible) {
    state.flash.visible = visible
  },
  SET_MESSAGES (state, messages) {
    state.flash.messages = messages
  },
  SET_TIMEOUT (state, timeout) {
    state.flash.timeout = timeout
  },
  SET_KIND (state, kind) {
    state.flash.kind = kind
  },
  SET_PAGE_SPECIFIC (state, value) {
    state.flash.pageSpecific = value
  },
  SET_ICON (state, icon) {
    state.flash.icon = icon
  },
  SET_COOKIE_VISIBLE (state, visible) {
    state.cookie.visible = visible
  },
  SET_COOKIE_MESSAGES (state, messages) {
    state.cookie.messages = messages
  },
  SET_COOKIE_TIMEOUT (state, timeout) {
    state.cookie.timeout = timeout
  },
  SET_COOKIE_KIND (state, kind) {
    state.cookie.kind = kind
  },
  SET_COOKIE_PAGE_SPECIFIC (state, value) {
    state.cookie.pageSpecific = value
  },
  SET_COOKIE_ICON (state, icon) {
    state.cookie.icon = icon
  }
}
